import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import SignOutLink from '../../../authentication/javascripts/components/SignOutLink'

export default class HeaderNav extends Component {
  render() {
    return(
      <nav className="navbar navbar-inverse navbar-fixed-top">
        <div className="container">
            <div className="navbar-header">
                <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
                    <span className="sr-only">Toggle navigation</span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                </button>
                <Link className='navbar-brand' to="/">Monitoring App</Link>
            </div>
            <div className="collapse navbar-collapse pull-right" id="bs-example-navbar-collapse-1">
                <ul className="nav navbar-nav">
                    <li>
                        {this.props.currentUser && this.props.currentUser.isSignedIn ? <a style={{fontWeight: 'bold'}}>{`Hello, ${this.props.currentUser.attributes.loginName}`}</a> : ''}
                    </li>
                    <li>
                        {this.props.currentUser && this.props.currentUser.isSignedIn ? <SignOutLink loginName={this.props.currentUser.attributes.loginName} /> : <Link to="/login">Login</Link>}
                    </li>
                    
                </ul>
            </div>
        </div>
      </nav>
    )
  }
}


// WEBPACK FOOTER //
// ./src/shared/javascripts/components/HeaderNav.jsx